// extracted by mini-css-extract-plugin
export default {"search-and-cart":"SearchAndCart-module__search-and-cart--m_Fcx"};